// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { addContactDetails } from '../../redux/reducers/contacts';

import Loader from '../../components/Loader/Loader';
import MessageBlock from '../../components/MessageBlock/MessageBlock';

import FormWrapper from '../../components/shared/FormWrapper';

import ContactAddForm from '../../components/Contacts/Add';

class ContactsAdd extends Component {
    onSubmit: Function;

    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(formValues) {
        const { dispatch, history } = this.props;

        const contactData = {
            contactEmail: formValues.email,
            contactForenames: formValues.forenames,
            contactSurname: formValues.surname,
            contactTelephone: formValues.telephone,
            contactTitle: formValues.title,
        };

        dispatch(addContactDetails(contactData)).then(updatedContact => {
            history.push('/contacts');
        });
    }

    render() {
        const { isFetching, errorFetching } = this.props;

        if (errorFetching) {
            return (
                <FormWrapper>
                    <MessageBlock message="An unexpected error occurred whilst loading this contact." />
                </FormWrapper>
            );
        }

        if (isFetching) {
            return (
                <FormWrapper>
                    <Loader message="Loading contact, please wait..." />
                </FormWrapper>
            );
        }

        return (
            <FormWrapper>
                <ContactAddForm onSubmit={this.onSubmit} />
            </FormWrapper>
        );
    }
}

const mapStateToProps = state => {
    const add = state.contacts.add;

    return {
        errorFetching: add.error,
        isFetching: add.fetching,
        contact: add.contact,
    };
};

export default withRouter(connect(mapStateToProps)(ContactsAdd));



// WEBPACK FOOTER //
// ./src/containers/ContactsAdd/ContactsAdd.js